module.exports = "/packs/media/images/icons/calculator-dadbcebad2a239773ed70dd66c759bac.png";